<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path d="M9.6 24V13.266H6V9h3.6V5.639C9.6 1.988 11.827 0 15.084 0a30.184 30.184 0 0 1 3.291.169v3.815h-2.259c-1.772 0-2.116.844-2.116 2.077V9h4l-.548 4.266H14V24" />
  </g>
</template>
